<svg class="sprite-icon" [ngClass]="{ 'd-none': !loaded }" role="img" [attr.width]="imageWidth" [attr.height]="imageHeight">
    <use [attr.xlink:href]="href"></use>
</svg>
